export default "__VITE_ASSET__C$F9a28X__"